export const documentTypeOptions = [
	{ value: 'html', label: 'html' },
	{ value: 'pdf', label: 'pdf' },
	{ value: 'csv', label: 'csv' },
	{ value: 'xlsx', label: 'xlsx' },
	{ value: 'xls', label: 'xls' },
	{ value: 'txt', label: 'txt' },
	{ value: 'md', label: 'md' },
];

export const approvalStatusOptions = [
	{ value: 'Approved', label: 'Approved' },
	{ value: 'Pending', label: 'Pending' },
];

export const providedByOptions = [
	{ value: 'ACM', label: 'ACM' },
	{ value: 'ACB', label: 'ACB' },
	{ value: 'APC', label: 'APC' },
	{ value: 'APP', label: 'APP' },
	{ value: 'AME', label: 'AME' },
	{ value: 'AMI', label: 'AMI' },
];

export const mimeToExtension = {
	'application/vnd.ms-excel': 'xls',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
	'application/pdf': 'pdf',
	'text/csv': 'csv',
	'text/html': 'html',
	'text/plain': 'txt',
	'text/markdown': 'md',
	'application/octet-stream': 'bin',
};

export const documentTypeMapping = {
	txt: 'plain',
	xlsx: 'sheet',
	xls: 'excel',
	html: 'html',
	pdf: 'pdf',
	csv: 'csv',
	md: 'markdown',
};

export const imageIssueType = [
	{ value: 3, label: '胶量过少' },
	{ value: 2, label: '虚压' },
	{ value: 1, label: '持粘力不足' },
	{ value: 4, label: '喷胶位置异常' },
	{ value: 5, label: '胶量过少 & 虚压' },
];
